import { type Virtualizer } from '@tanstack/react-virtual';
import { type MutableRefObject } from 'react';

import { WORKSPACE_AGENT_AUTOMATION_ROW_ID_ATTRIBUTE } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentAutomationRowFocusAttribute';
import { type WorkspaceAgentSessionVirtualRow } from '~/components/v2/components/workspace/workspace-agent-panel/utils/buildWorkspaceAgentSessionVirtualRows';

export const getWorkspaceAgentMyTasksAutomationRowIndex = ({
  automationId,
  virtualRows,
}: {
  automationId: string;
  virtualRows: WorkspaceAgentSessionVirtualRow[];
}): number => virtualRows.findIndex((row) => row.type === 'automation' && row.automation.id === automationId);

type FocusWorkspaceAgentMyTasksAutomationRowParams = {
  automationId: string;
  scrollElementRef: MutableRefObject<HTMLElement | null>;
  virtualItems: { index: number }[];
  virtualRows: WorkspaceAgentSessionVirtualRow[];
  virtualizer: Virtualizer<HTMLDivElement, Element>;
};

export const focusWorkspaceAgentMyTasksAutomationRow = ({
  automationId,
  scrollElementRef,
  virtualItems,
  virtualRows,
  virtualizer,
}: FocusWorkspaceAgentMyTasksAutomationRowParams): boolean => {
  const rowIndex = getWorkspaceAgentMyTasksAutomationRowIndex({ automationId, virtualRows });

  if (rowIndex < 0) {
    return false;
  }

  const isRowRendered = virtualItems.some((item) => item.index === rowIndex);

  if (!isRowRendered) {
    virtualizer.scrollToIndex(rowIndex, { align: 'auto' });
    return false;
  }

  const row = scrollElementRef.current?.querySelector<HTMLElement>(
    `[${WORKSPACE_AGENT_AUTOMATION_ROW_ID_ATTRIBUTE}="${automationId}"]`,
  );

  if (!row) {
    return false;
  }

  row.focus({ preventScroll: true });
  return true;
};
